<!-- Page Header -->
<div class="page-header">
  <div class="page-header-left">
    <h2 class="page-title">Dashboard</h2>
    <p class="page-subtitle">{{ today | date:'EEEE, MMMM d, y' }}</p>
  </div>
  <div class="page-header-right">
    <button class="btn btn-secondary btn-sm">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           width="15" height="15">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
        <polyline points="7 10 12 15 17 10"/>
        <line x1="12" y1="15" x2="12" y2="3"/>
      </svg>
      Export
    </button>
    <button class="btn btn-primary btn-sm">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           width="15" height="15">
        <line x1="12" y1="5" x2="12" y2="19"/>
        <line x1="5" y1="12" x2="19" y2="12"/>
      </svg>
      New Report
    </button>
  </div>
</div>

<!-- KPI Cards -->
<div class="stats-grid">

  <!-- Total Users -->
  <div class="stat-card stat-card--primary">
    <div class="stat-card-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           width="22" height="22">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    </div>
    <div class="stat-card-body">
      <span class="stat-label">Total Users</span>
      <span class="stat-value">1,248</span>
      <span class="stat-trend stat-trend--up">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="13" height="13"><polyline points="18 15 12 9 6 15"/></svg>
        12.5% vs last month
      </span>
    </div>
  </div>

  <!-- Revenue -->
  <div class="stat-card stat-card--success">
    <div class="stat-card-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           width="22" height="22">
        <line x1="12" y1="1" x2="12" y2="23"/>
        <path d="M17 5H9.5a3.5 3.5 0 1 0 0 7h5a3.5 3.5 0 1 1 0 7H6"/>
      </svg>
    </div>
    <div class="stat-card-body">
      <span class="stat-label">Revenue</span>
      <span class="stat-value">$48.2K</span>
      <span class="stat-trend stat-trend--up">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="13" height="13"><polyline points="18 15 12 9 6 15"/></svg>
        8.3% vs last month
      </span>
    </div>
  </div>

  <!-- Open Reports -->
  <div class="stat-card stat-card--warning">
    <div class="stat-card-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           width="22" height="22">
        <line x1="18" y1="20" x2="18" y2="10"/>
        <line x1="12" y1="20" x2="12" y2="4"/>
        <line x1="6"  y1="20" x2="6"  y2="14"/>
      </svg>
    </div>
    <div class="stat-card-body">
      <span class="stat-label">Open Reports</span>
      <span class="stat-value">186</span>
      <span class="stat-trend stat-trend--down">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="13" height="13"><polyline points="6 9 12 15 18 9"/></svg>
        3.2% vs last month
      </span>
    </div>
  </div>

  <!-- Active Sessions -->
  <div class="stat-card stat-card--info">
    <div class="stat-card-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           width="22" height="22">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
      </svg>
    </div>
    <div class="stat-card-body">
      <span class="stat-label">Active Sessions</span>
      <span class="stat-value">93</span>
      <span class="stat-trend stat-trend--up">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="13" height="13"><polyline points="18 15 12 9 6 15"/></svg>
        5.1% right now
      </span>
    </div>
  </div>

</div>

<!-- Charts Row -->
<div class="charts-row">

  <!-- Monthly Bar Chart -->
  <div class="card chart-card">
    <div class="card-header">
      <h3 class="card-title">Monthly Overview</h3>
      <span class="card-subtitle">Activity across all modules</span>
    </div>
    <div class="bar-chart">
      <div class="bar-item" *ngFor="let item of monthlyData">
        <div class="bar-track">
          <div class="bar-fill" [style.height.%]="barHeight(item.value)" [title]="item.value + ' activities'"></div>
        </div>
        <span class="bar-label">{{ item.month }}</span>
      </div>
    </div>
  </div>

  <!-- Category Breakdown -->
  <div class="card breakdown-card">
    <div class="card-header">
      <h3 class="card-title">Content Breakdown</h3>
      <span class="card-subtitle">Distribution by type</span>
    </div>

    <div class="total-badge">
      <span class="total-number">1,248</span>
      <span class="total-label">Total items</span>
    </div>

    <div class="category-list">
      <div class="category-item" *ngFor="let cat of categories">
        <div class="category-meta">
          <span class="category-dot" [style.background-color]="cat.color"></span>
          <span class="category-name">{{ cat.label }}</span>
          <span class="category-count">{{ cat.count }}</span>
          <span class="category-percent">{{ cat.percent }}%</span>
        </div>
        <div class="progress-track">
          <div class="progress-fill" [style.width.%]="cat.percent" [style.background-color]="cat.color"></div>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- Recent Activity Table -->
<div class="card table-card">
  <div class="card-header">
    <h3 class="card-title">Recent Activity</h3>
    <a href="#" class="card-action">View all</a>
  </div>

  <div class="table-wrapper">
    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>User</th>
          <th>Action</th>
          <th>Time</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of recentActivity">
          <td class="row-id">{{ row.id }}</td>
          <td>
            <div class="user-cell">
              <div class="user-avatar-sm">{{ row.initials }}</div>
              <span class="user-name-cell">{{ row.user }}</span>
            </div>
          </td>
          <td class="action-cell">{{ row.action }}</td>
          <td class="time-cell">{{ row.time }}</td>
          <td>
            <span class="status-badge" [ngClass]="'status-badge--' + row.status">
              {{ row.status }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
